export default "https://cdn-static.gokick.com/assets/efda86aac2f53028585758eeb3b3c0048c8387b3/images/choco-chill.f91442e53028d067e0a40cd80e4e8aae.png";